import React, { useEffect } from "react";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import Card from "common/components/Card/Card.jsx";
import CardBody from "common/components/Card/CardBody.jsx";
import ChartistGraph from "react-chartist";
import loadContent from "core-module/hoc/loadContent";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

var Chartist = require("chartist");

const donutVariables = {
  options: {
    donut: true,
    donutWidth: 20,
    startAngle: 0,
    showLabel: false,
  },
  // for animation
  animation: {
    draw: function (data) {
      if (data.type === "slice") {
        // Get the total path length in order to use for dash array animation
        var pathLength = data.element._node.getTotalLength();

        // Set a dasharray that matches the path length as prerequisite to animate dashoffset
        data.element.attr({
          "stroke-dasharray": pathLength + "px " + pathLength + "px",
        });

        // Create animation definition while also assigning an ID to the animation for later sync usage
        var animationDefinition = {
          "stroke-dashoffset": {
            id: "anim" + data.index,
            dur: 200,
            from: -pathLength + "px",
            to: "0px",
            easing: Chartist.Svg.Easing.easeOutQuint,
            // We need to use `fill: 'freeze'` otherwise our animation will fall back to initial (not visible)
            fill: "freeze",
          },
        };

        // If this was not the first slice, we need to time the animation so that it uses the end sync event of the previous animation
        if (data.index !== 0) {
          animationDefinition["stroke-dashoffset"].begin =
            "anim" + (data.index - 1) + ".end";
        }

        // We need to set an initial value before the animation starts as we are not in guided mode which would do that for us
        data.element.attr({
          "stroke-dashoffset": -pathLength + "px",
        });

        // We can't use guided mode as the animations need to rely on setting begin manually
        // See http://gionkunz.github.io/chartist-js/api-documentation.html#chartistsvg-function-animate
        data.element.animate(animationDefinition, false);
      }
    },
  },
};

const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  stats: importedStyle.stats,
};

const DataCapDonut = (props) => {
  const { classes, passExtraGbUp } = props;
  const loyalty_extra_gb = props.getData("loyalty_extra_gb");

  useEffect(() => {
    passExtraGbUp(loyalty_extra_gb);
  }, [loyalty_extra_gb, passExtraGbUp]);

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card chart>
          <CardBody>
            {props.getData("loyalty_extra_gb") > 0 ? (
              <GridContainer>
                <GridItem xs={12}>
                  <h4>
                    Thank you for being a loyal customer! <br />
                    To show our appreciation of your support through the years,
                    we are providing you {props.getData(
                      "loyalty_extra_gb"
                    )}{" "}
                    <small>GB</small> added monthly to your traffic.
                  </h4>
                  <br />
                </GridItem>
              </GridContainer>
            ) : null}
            <GridContainer>
              <GridItem xs={12} sm={6} md={6}>
                <br />
                <ChartistGraph
                  className="ct-chart-white-colors .ct-chart-touch-action-auto"
                  data={{
                    series: [
                      {
                        value: props.getData("base_cap"),
                        className: "ct-pie-serie-basecap",
                      },
                      {
                        value: props.getData("loyalty_extra_gb"),
                        className: "ct-pie-serie-loyalty",
                      },
                      {
                        value: props.getData("onetime_extra_gb"),
                        className: "ct-pie-serie-trafficpack",
                      },
                    ],
                  }}
                  type="Pie"
                  options={{
                    ...donutVariables.options,
                    total: props.getData("total_cap"),
                  }}
                  listener={donutVariables.animation}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <br />
                <h4 className={classes.cardTitle}>
                  Your total cap is {props.getData("total_cap")}{" "}
                  <small>GB</small>
                </h4>
                <span className="badge-square badge-primaryRed " />
                <p className={classes.cardCategory}>
                  {props.getData("base_cap")} <small>GB</small> package limit
                </p>

                {props.getData("loyalty_extra_gb", "value") > 0 ? (
                  <div key="loyalty">
                    <span className="badge-square badge-primaryDarkBlue " />
                    <p className={classes.cardCategory}>
                      {props.getData("loyalty_extra_gb")} <small>GB</small>{" "}
                      loyalty extra <small>GBs</small>
                    </p>
                  </div>
                ) : null}
                {props.getData("onetime_extra_gb", "value") > 0 ? (
                  <div key="traffickpack">
                    <span className="badge-square badge-primaryLightBlue " />
                    <p className={classes.cardCategory}>
                      {props.getData("onetime_extra_gb")} <small>GB</small>{" "}
                      added traffic packs
                    </p>
                  </div>
                ) : null}
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem>
                <br />
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default withStyles(styles)(
  loadContent("user.session/broadbandtraffic", DataCapDonut)
);
